/**
 * Google Ads + GA4 conversion tracking helpers.
 *
 * Fires events via window.gtag (loaded in public/index.html) for:
 *   - Phone clicks (any <a href="tel:..."> on the site)
 *   - Form submissions (devis / contact)
 *
 * These events appear in:
 *   - GA4 (G-ZVRRB91H5J) → Reports → Engagement → Events
 *   - Google Tag container (GT-W6KDBW87)
 *
 * To turn them into Google Ads conversion actions:
 *   1. Open Google Ads → Tools → Conversions → "+ New conversion"
 *   2. Choose "Import from Google Analytics 4 properties"
 *   3. Select event `generate_lead` (or `phone_click` / `form_submit`)
 *   4. Set value (e.g. 80 € = average gross margin per intervention)
 *   5. Apply to your campaigns
 */

const send = (event, params = {}) => {
    if (typeof window === "undefined" || typeof window.gtag !== "function") return;
    window.gtag("event", event, params);
};

export const trackPhoneClick = (phone = "", source = "unknown") => {
    send("phone_click", {
        phone_number: phone,
        source,
        page_path: typeof window !== "undefined" ? window.location.pathname : "",
    });
    // Standard Google "lead" event — recognized as conversion in Google Ads
    send("generate_lead", {
        currency: "EUR",
        value: 80, // average gross margin per intervention; adjust in Ads UI
        method: "phone",
        source,
    });
};

export const trackFormSubmit = (formName = "contact") => {
    send("form_submit", { form_name: formName });
    send("generate_lead", {
        currency: "EUR",
        value: 60, // forms convert at ~75% of calls; lower base value
        method: "form",
        form_name: formName,
    });
};

/**
 * Install a global delegated click listener that fires `trackPhoneClick`
 * for ANY `a[href^="tel:"]` click. Includes future-added phone links automatically.
 */
export const installPhoneClickTracking = () => {
    if (typeof document === "undefined") return () => {};
    const handler = (e) => {
        const anchor = e.target && e.target.closest && e.target.closest('a[href^="tel:"]');
        if (!anchor) return;
        const phone = (anchor.getAttribute("href") || "").replace(/^tel:/, "");
        const source =
            anchor.getAttribute("data-testid") ||
            anchor.getAttribute("data-source") ||
            anchor.getAttribute("aria-label") ||
            "phone_link";
        trackPhoneClick(phone, source);
    };
    document.addEventListener("click", handler, true);
    return () => document.removeEventListener("click", handler, true);
};
